export const PROTOCOL_EVENT_TYPE = {
    WELCOME_RECEIVED: "WELCOME_RECEIVED",
    ERROR_RECEIVED: "ERROR_RECEIVED",
    PONG_RECEIVED: "PONG_RECEIVED",
    CALL_CREATED_RECEIVED: "CALL_CREATED_RECEIVED",
    CALL_INCOMING_RECEIVED: "CALL_INCOMING_RECEIVED",
    CALL_ACCEPTED_RECEIVED: "CALL_ACCEPTED_RECEIVED",
    CALL_RECONNECTING_RECEIVED: "CALL_RECONNECTING_RECEIVED",
    CALL_IN_CALL_RECEIVED: "CALL_IN_CALL_RECEIVED",
    CALL_RESUMED_RECEIVED: "CALL_RESUMED_RECEIVED",
    CALL_ENDED_RECEIVED: "CALL_ENDED_RECEIVED",
    SDP_OFFER_RECEIVED: "SDP_OFFER_RECEIVED",
    SDP_ANSWER_RECEIVED: "SDP_ANSWER_RECEIVED",
    ICE_CANDIDATE_RECEIVED: "ICE_CANDIDATE_RECEIVED",
    CALL_STATE_RECEIVED: "CALL_STATE_RECEIVED",
};
